import {EntitySpecialPurpose} from '../../backend/enums/entity-special-purpose';
import {translations} from '../../i18n/translations';

/**
 * Array with the available entity special purposes in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(entitySpecialPurposes[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const entitySpecialPurposes: Array<{translation: string; type: EntitySpecialPurpose}> = [
  {
    translation: translations.entity_special_purposes[EntitySpecialPurpose.Commercial],
    type: EntitySpecialPurpose.Commercial,
  },
  {
    translation: translations.entity_special_purposes[EntitySpecialPurpose.Demonstration],
    type: EntitySpecialPurpose.Demonstration,
  },
  {
    translation: translations.entity_special_purposes[EntitySpecialPurpose.Research],
    type: EntitySpecialPurpose.Research,
  },
  {
    translation: translations.entity_special_purposes[EntitySpecialPurpose.Testing],
    type: EntitySpecialPurpose.Testing,
  },
];
